"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _constants = require("../_form/constants");
var _context = require("../context");
var _utils2 = require("../utils");
var _constants2 = require("./constants");
const Ring = (0, _context.styledWithTheme)('div')(_ref => {
  let {
    disabled,
    error,
    theme: {
      isInHighContrast
    }
  } = _ref;
  let backgroundColor;
  let borderColor;
  let checkedBorderColor;
  let interactiveStyles = {};
  if (disabled) {
    backgroundColor = (0, _utils.token)('color.input.bg-disabled');
    if (isInHighContrast) {
      borderColor = checkedBorderColor = _utils2.WHCM_DISABLED_ITEM_COLOR;
    } else {
      if (error) {
        borderColor = (0, _utils.token)('color.status.critical-border-disabled');
        checkedBorderColor = (0, _utils.token)('color.status.critical-border-disabled');
      } else {
        borderColor = (0, _utils.token)('color.input.border-disabled');
        checkedBorderColor = (0, _utils.token)('color.input.selected.border-disabled');
      }
    }
  } else {
    backgroundColor = (0, _utils.token)('color.input.bg-default');
    let hoverColor;
    let activeColor;
    if (error) {
      borderColor = (0, _utils.token)('color.status.critical-border-default');
      checkedBorderColor = (0, _utils.token)('color.input.selected.critical-bg-default');
      hoverColor = (0, _utils.token)('color.input.selected.critical-bg-hover');
      activeColor = (0, _utils.token)('color.input.selected.critical-bg-pressed');
    } else {
      borderColor = (0, _utils.token)('color.input.border-default');
      checkedBorderColor = (0, _utils.token)('color.input.selected.bg-default');
      hoverColor = (0, _utils.token)('color.input.selected.bg-hover');
      activeColor = (0, _utils.token)('color.input.border-pressed');
    }
    interactiveStyles = {
      'input:focus-visible ~ &': {
        outline: "".concat((0, _utils2.px)(_constants.OUTLINE_BORDER_WIDTH), " solid ").concat((0, _utils.token)('color.border.border-focus')),
        outlineOffset: 1
      },
      'input:hover ~ &, input:hover ~ &:before': {
        borderColor: hoverColor
      },
      'input:hover ~ &': {
        borderWidth: _constants2.HOVERED_RING_SIZE
      },
      'input:checked:hover ~ &': {
        borderWidth: _constants2.CHECKED_RING_SIZE
      },
      'input:active ~ &, input:active ~ &:before': {
        borderColor: activeColor
      }
    };
  }
  return {
    width: (0, _utils2.px)(_utils2.A11Y_INLINE_MIN_SIZE),
    height: (0, _utils2.px)(_utils2.A11Y_INLINE_MIN_SIZE),
    boxSizing: 'border-box',
    borderRadius: (0, _utils.token)('dimensions.border.radius.round'),
    backgroundColor,
    border: "".concat(_constants2.DEFAULT_RING_SIZE, " solid ").concat(borderColor),
    transition: 'border-color 0.2s, border-width 0.2s',
    'input:checked ~ &': {
      borderWidth: _constants2.CHECKED_RING_SIZE,
      borderColor: checkedBorderColor
    },
    ...interactiveStyles
  };
});
var _default = exports.default = Ring;